import React from 'react';

import * as validation from '../../lib/validation';
import Input from '../Input';

const validAnswer = validation.create((answer, {isDecimal}) => isDecimal(answer));

function NumericInput({id, label, question, values, onChange, invalid}) {
  const answer = values.length > 0 ? values[0] : '';

  return (
    <Input
      id={id ? id : `answer-${question.id}`}
      label={label}
      type="number"
      step="any"
      value={answer}
      onChange={e => onChange([e.target.value], validAnswer(e.target.value))}
      invalid={invalid}
    />
  );
}

export default NumericInput;